var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row wrapper border-bottom white-bg margin-bottom-5 hidden-print"},[_c('div',{staticClass:"col-sm-8"},[_c('h2',{staticClass:"margin-top-10"},[_c('b',[_vm._v(_vm._s(_vm.$root.tituloDaPagina))])])])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b74d3f68","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./FrontEnd/componentes/PageHeaderTransparencia.vue
// module id = 2243
// module chunks = 0